
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.124 15.86A4.938 4.938 0 017.03 18c-1.65 0-3.143-.78-4.094-2.14a5.018 5.018 0 01-.623-4.605L3.466 8h7.127l1.155 3.255a5.021 5.021 0 01-.624 4.605zM3.994 6h5.954V2H3.993v4zm9.593 4.582L11.933 6V0H2.008v6L.413 10.582C-1.213 15.172 2.163 20 7 20s8.213-4.828 6.587-9.418z"}})])
          )
        }
      }
    